export const AuthenticationMutations = {
  setMultifactorAuthenticationSettings: (state, payload) => {
    state.multifactorAuthenticationSettings = payload
  },

}
